import styled from 'styled-components'

import { CheckCurrencyForm } from '@root/features/premium/check-currency'
import { useTranslation } from '@root/shared/localization'

import type { CheckCurrencyReatom } from '@root/features/premium/check-currency'
type Props = {
  model: CheckCurrencyReatom
}

export const PremiumPurchaseSearch: React.FC<Props> = ({ model }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Title>{t('premium.search.title')}</Title>
      <SubTitle>{t('premium.search.subtitle-check-token')}</SubTitle>
      <CheckCurrencyForm model={model} mode="currency" />
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-1);
  border: 1px solid var(--background-3);

  display: grid;

  position: relative;
  overflow: hidden;

  border-radius: 12px;
  transition: border 0.5s linear;
  grid-template-rows: auto 1fr auto;
  padding: 18px 16px 24px;

  height: 140px;
`

const Title = styled.h2`
  color: var(--text-12);
  text-align: center;

  font-size: 14px;
  font-weight: 700;
  line-height: normal;
`

const SubTitle = styled.h2`
  color: var(--text-8);
  text-align: center;

  font-size: 14px;
  font-weight: 400;
  line-height: normal;
`
